import '.ag{position:relative;}.ssr-plugin'
import '.j7{width:64px;}.ssr-plugin'
import '.j8{height:64px;}.ssr-plugin'
import '.aj{flex-shrink:0;}.ssr-plugin'
import '.bq{position:absolute;}.ssr-plugin'
import '.j9{bottom:-4px;}.ssr-plugin'
import '.hy{right:-4px;}.ssr-plugin'
import '.fo{border-radius:50%;}.ssr-plugin'
import '.bx{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bf{overflow:hidden;}.ssr-plugin'
import '.ja{width:32px;}.ssr-plugin'
import '.jb{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ag j7 j8 aj"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bq j9 hy fo bx bf ja jb"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
